import { makeStyles } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  alert: {
    borderRadius: 0
  },
  userFilter: {
    margin: theme.spacing(3, 0, 3, 3),
    width: 350
  }
}));

export const AlertContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(0, 2, 2, 2)
}));
